module.exports = __webpack_public_path__ + "static/media/icono-corregir.433d3ad7.png";